import styles from './entry-main-image.module.scss';
import flagMochi from '#/guest-aps/assets/flag.png';

interface EntryMainImageProps {
  imageUrl: string | undefined;
}

export const EntryMainImage = ({ imageUrl }: EntryMainImageProps) => {
  if (imageUrl == null) {
    return (
      <div className={styles.lottie}>
        <img src={flagMochi} alt="flag" />
      </div>
    );
  }

  return (
    <div className={styles.lottie}>
      <img src={imageUrl} alt="aps-partner" />
    </div>
  );
};
